/**
 * SAAS-2b · C · 顶部导航版式下顶栏右侧下拉（铃铛「待我处理」/ 账号菜单）被 header 的 overflow-x-auto 裁掉（THEME-1 遗留）。
 * 顶部导航版式：按按钮位置用 fixed 定位（右对齐、按钮下方 48px = 原 top-12），滚动页面 / 改窗口大小时收起（下拉自己里面滚不收）。
 * 侧栏版式（= 公司站）：原样返回 `absolute right-0 top-12`、不加 style——DOM 和样式一个字都不变（逐像素 0 差异）。
 */
import { useEffect, useState, type CSSProperties, type RefObject } from "react";
import { useAdminLayout } from "@/theme/useTheme";

export function useTopnavDropdown(anchor: RefObject<HTMLElement>, open: boolean, close: () => void): { cls: string; style?: CSSProperties } {
  const topnav = useAdminLayout() === "topnav";
  const [pos, setPos] = useState<{ top: number; right: number } | null>(null);
  useEffect(() => {
    if (!topnav || !open || !anchor.current) return;
    const r = anchor.current.getBoundingClientRect();
    setPos({ top: r.top + 48, right: Math.max(8, window.innerWidth - r.right) });
    const onResize = () => close();
    const onScroll = (e: Event) => {
      if (anchor.current && e.target instanceof Node && anchor.current.contains(e.target)) return;   // 下拉里面的列表自己滚，不收
      close();
    };
    window.addEventListener("resize", onResize);
    window.addEventListener("scroll", onScroll, true);
    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("scroll", onScroll, true);
    };
  }, [topnav, open, close, anchor]);
  if (!topnav) return { cls: "absolute right-0 top-12" };
  return { cls: "", style: pos ? { position: "fixed", top: pos.top, right: pos.right } : { position: "fixed", visibility: "hidden" } };
}
